// extracted by mini-css-extract-plugin
export var cardLayout = "_2b-1";
export var paginationContainer = "_2b-0";